import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {CasinoPage, CasinoPageSeoEditor, CasinoTabSeo, ListCasinoPageRequest, ListCasinoPageResponse, SaveCasinoTabSeoRequest} from "../http/protocol";
import {HttpService} from "../http/HttpService";



export class AdminCasinoPageService extends AbstractAdminEntityService<CasinoPage, ListCasinoPageResponse> {

    constructor(http : HttpService) {
        super("/casino-page",http);
    }

    getSeo(casinoPageId: number): Promise<CasinoPageSeoEditor> {
        return this.http.get(`${this.entityPath}/${casinoPageId}/seo`);
    }

    saveSeo(casinoPageId: number, request: SaveCasinoTabSeoRequest): Promise<CasinoTabSeo> {
        return this.http.put(`${this.entityPath}/${casinoPageId}/seo`, request);
    }
}
